
<div *ngIf="loading" class="d-flex justify-content-center">
    <H5 class="text-warning my-5">Chargement en cours...</H5>
</div>
<div *ngIf="!loading" id="mailscard" class="card-body">
    <table class="table table-striped table-sm" style="width: 100%;">
        <thead>
            <th><label class="control-label">Date/heure</label></th>
            <th><label class="control-label">Emetteur</label></th>
            <th><label class="control-label">Destinataire(s)</label></th>
            <th><label class="control-label">Copie(s)</label></th>
            <th><label class="control-label">Objet</label></th>                
        </thead>
        <tbody>
            <tr *ngFor="let mail of supplierMails">
                <td>
                    <a class="control-label" href="javascript:void(0);" btnDebounceClick (debounceClick)="triggerModal(mail,modalMailBody)">{{mail.DateSent |date: 'dd/MM/yyyy hh:mm:ss'}}</a>
                </td>
                <td><a href="javascript:void(0);" btnDebounceClick (debounceClick)="triggerModal(mail,modalMailBody)">{{mailSender(mail)}}</a></td>
                <td><a href="javascript:void(0);" btnDebounceClick (debounceClick)="triggerModal(mail,modalMailBody)">{{mail.To}}</a></td>
                <td><a href="javascript:void(0);" btnDebounceClick (debounceClick)="triggerModal(mail,modalMailBody)">{{mail.CC}}</a></td>
                <td>
                    <div class="d-flex">
                        <div class="flex-grow-1"><a href="javascript:void(0);" btnDebounceClick (debounceClick)="triggerModal(mail,modalMailBody)">{{mail.Subject}}</a></div>
                        <button  type="button" class="btn btn-xs btn-primary ml-1" (click)="triggerModal(mail,modalMailBody)" data-toggle="tooltip" title="Corps du mail">
                            <i class="fas fa-envelope-open-text"></i>
                        </button>
                    </div>
                </td>
                
            </tr>
        </tbody>
    </table>
</div>

<ng-template #modalMailBody let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">{{selectedMail.Subject}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="small" [innerHTML]="selectedMail.Body"></div>            
    </div>
    <div class="modal-footer text-center">
        <div style="width: 100%; text-align: center;">
            <button type="button" class="btn btn-warning" (click)="modal.close()" paflabel="Fermer"></button>
        </div>
    </div>
</ng-template>
